import Swiper from 'swiper';

// Swiper slider on News
(function ($, Drupal) {
  Drupal.behaviors.newsSlider = {
    attach: function (context, settings) {
      const menuFilters = context.querySelector('.view-id-news .js-menu-filters');

      function slidesFiltering(el, filterBtns, newsSlider) {
        filterBtns.forEach((btn) => {
          btn.classList.remove('active');
        });

        el.classList.add('active');

        const tag = el.getAttribute('href').replace('#', '');
        const allSlides = newsSlider.wrapperEl.querySelectorAll('.swiper-slide');

        for (const slide of allSlides) {
          const filtersAttr = slide.firstElementChild.getAttribute('data-filter');
          const filters = filtersAttr.split(' ');

          if (filters.indexOf(tag) > -1) {
            // Show
            slide.classList.remove('hide');
          } else {
            // Hide
            slide.classList.add('hide');
          }
        }
        newsSlider.update();
        newsSlider.lazy.load();
      }

      if ($('.view-id-news .swiper-slide', context).length > 1) {
        let newsSliderOptions;

        if (menuFilters) {
          const filterBtns = menuFilters.querySelectorAll('.js-filter-slides');
          const firstChild = menuFilters.firstElementChild.querySelector('.js-filter-slides');

          newsSliderOptions = {
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            grabCursor: true,
            lazy: true,
            // If you use slidesPerView "auto" or slidesPerView > 1,
            // then you should also enable watchSlidesVisibility and Swiper will load images in currently visible slides
            watchSlidesProgress: true,
            watchSlidesVisibility: true,

            // Navigation arrows
            navigation: {
              nextEl: '.view-id-news .swiper-button-next',
              prevEl: '.view-id-news .swiper-button-prev',
            },
            // Observer : Set to true to enable Mutation Observer on Swiper and its elements.
            // In this case Swiper will be updated (reinitialized) each time if you change its style (like hide/show)
            // or modify its child elements (like adding/removing slides)
            observer: true,

            init: false,
            breakpoints: {
              768: {
                slidesPerGroup: 1,
              },
              640: {
                slidesPerGroup: 1,
                // Free Mode
                // Only on mobile devices
                freeMode: true,
              }
            }
          };

          const newsSlider = new Swiper('.view-id-news .swiper-container', newsSliderOptions);

          newsSlider.on('init', function () {
            slidesFiltering(firstChild, filterBtns, newsSlider);
          });

          newsSlider.init();

          filterBtns.forEach((btn) => {
            btn.addEventListener('click', function (ev) {
              ev.preventDefault();

              slidesFiltering(btn, filterBtns, newsSlider);
            });
          });
        } else {
          newsSliderOptions = {
            slidesPerView: 'auto',
            slidesPerGroup: 2,
            grabCursor: true,
            lazy: true,
            // If you use slidesPerView "auto" or slidesPerView > 1,
            // then you should also enable watchSlidesVisibility and Swiper will load images in currently visible slides
            watchSlidesProgress: true,
            watchSlidesVisibility: true,

            // Navigation arrows
            navigation: {
              nextEl: '.view-id-news .swiper-button-next',
              prevEl: '.view-id-news .swiper-button-prev',
            },
            // Observer : Set to true to enable Mutation Observer on Swiper and its elements.
            // In this case Swiper will be updated (reinitialized) each time if you change its style (like hide/show)
            // or modify its child elements (like adding/removing slides)
            observer: true,
            breakpoints: {
              640: {
                slidesPerGroup: 1,
                // Free Mode
                // Only on mobile devices
                freeMode: true,
              }
            }
          };

          const newsSlider = new Swiper('.view-id-news .swiper-container', newsSliderOptions);
        }

      } else {
        $('.view-id-news .swiper-navigation', context).addClass('hide');
      }
    }
  };
})(jQuery, Drupal);
